import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import MarkdownEditor from 'Common/Components/v2/MarkdownEditor';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import { updateVulnTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { selectVulnTemplateDetail, selectVulnTemplatePermissions } from 'store/KnowledgeBase/selectors';
import { selectReadOnly } from 'store/Faraday/selectors';

const TAB = 'general';
const ID = 'description';

const Description = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const vulnTemplate = useSelector(selectVulnTemplateDetail);
  const readOnly = useSelector(selectReadOnly);
  const permissions = useSelector(selectVulnTemplatePermissions);
  const id = get(vulnTemplate, '_id', 0);
  const description = get(vulnTemplate, 'description', '');
  const disabled = readOnly || !permissions?.update?.allowed;
  const isExpanded = useExpandable(TAB, ID, description, id);

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'manage.detail.tab.general.description' }) } tab={ TAB } id={ ID }>
      <MarkdownEditor
        value={ description }
        onBlur={ (value) => dispatch(updateVulnTemplate(id, { description: value })) }
        disabled={ disabled }
        minHeight={ 170 }
      />
    </ExpandableWrapper>
  );
};

export default Description;
